import type * as React from 'react';
import { Page } from '@/components/page';

export function NotFoundPage(): React.JSX.Element {
  return (
    <Page title="Not found" description="That page does not exist in this panel.">
      <div className="rounded-card border border-line bg-surface px-6 py-16 text-center">
        <p className="text-sm text-ink-soft">Check the link, or pick a section from the sidebar.</p>
      </div>
    </Page>
  );
}
